"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseModule(storeConfig, currentNameSpace, currentParsingState) {
    if (!currentNameSpace)
        currentNameSpace = '';
    if (!currentParsingState)
        currentParsingState = { actions: [], getters: [], mutations: [] };
    // for each storeConfig.getters add to currentParsingState
    for (var getter in storeConfig.getters) {
        currentParsingState.getters.push(currentNameSpace + "/" + getter);
    }
    // for each storeConfig.actions add to currentParsingState
    for (var action in storeConfig.actions) {
        currentParsingState.actions.push(currentNameSpace + "/" + action);
    }
    // for each storeConfig.mutations add to currentParsingState
    for (var mutation in storeConfig.mutations) {
        var mutationInfo = {
            mutation: storeConfig.mutations[mutation],
            mutationKey: currentNameSpace + "/" + mutation,
            moduleStatePath: currentNameSpace.replace('/', '.') //+'state'
        };
        currentParsingState.mutations.push(mutationInfo);
    }
    // for each storeConfig.module
    if (storeConfig.modules) {
        for (var storeModule in storeConfig.modules) {
            var nameSpace = currentNameSpace + "/" + storeModule;
            if (!storeConfig.modules[storeModule].namespaced) {
                nameSpace = currentNameSpace;
            }
            parseModule(storeConfig.modules[storeModule], nameSpace, currentParsingState);
        }
    }
    return currentParsingState;
}
exports.parseModule = parseModule;
//# sourceMappingURL=parseStore.js.map